module.exports = __webpack_public_path__ + "static/TNM079___Modeling_And_Animation__Lab_5-60ed7420b26020027e16933320c66eff.pdf";